module.exports = __webpack_public_path__ + "static/media/06.3e912c16.jpg";